import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import MainApp from "./mainApp";
import { SharedValueProvider } from "./components/Constants/constants";
import { UserSettingsProvider } from "./contexts/UserSettingsContext";
import { BulkProcessingProvider } from "./contexts/BulkProcessingContext";
import MobileModal from "./components/MobileModal";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import LandingPage from "./components/LandingPage/landingPage";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Login from "./Login/Login";
import "./components/Constants/brands/deloitte/theme.css";
import "./components/Constants/brands/comply/theme.css";

// Create a default theme for the entire app
const defaultTheme = createTheme({
  typography: {
    fontFamily: '"Poppins", sans-serif',
    allVariants: {
      fontFamily: '"Poppins", sans-serif',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "*, *::before, *::after": {
          fontFamily: '"Poppins", sans-serif !important',
        },
        body: {
          fontFamily: '"Poppins", sans-serif !important',
        },
      },
    },
  },
});

function isMobileDevice() {
  return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

const App = () => {
  if (isMobileDevice()) {
    return <MobileModal />;
  }

  return (
    <BrowserRouter>
      <ThemeProvider theme={defaultTheme}>
        <SharedValueProvider>
          <UserSettingsProvider>
            <BulkProcessingProvider>
              <Switch>
                <Route exact path="/" component={Login} />
                <Route path="/*" component={MainApp} />
              </Switch>
            </BulkProcessingProvider>
          </UserSettingsProvider>
        </SharedValueProvider>
      </ThemeProvider>
      <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} closeOnClick />
    </BrowserRouter>
  );
};

export default App;
